import React from 'react';

import { defineMessage, useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';

import { Text } from '@atlaskit/primitives/compiled/text';

import { asNumberValue } from '../../../../../../../../common/types/form/form-fields/field-values/utils';
import { asFormRankingField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

const selectedValue = defineMessage({
	id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.rating-input.view.selected-value',
	defaultMessage: '{selected}/{max}',
	description:
		'Displays the selected rating value out of the maximum, e.g. "3/5". selected is the chosen rating number, max is the highest rating option.',
});

const noValue = defineMessage({
	id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.rating-input.view.no-value',
	defaultMessage: '-/{max}',
	description:
		'Displayed when no rating has been selected, showing only the maximum rating value, e.g. "-/5".',
});

export const ViewRatingInput = ({
	fieldId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);

	const intl = useIntl();
	const formField = useFormField({ fieldId });
	const formRankingField = asFormRankingField(formField);

	if (formRankingField === undefined) {
		return <></>;
	}

	const currentValue = asNumberValue(formRankingField.value);
	const max = formRankingField.options[formRankingField.options.length - 1]?.id ?? '';

	const text =
		currentValue?.number !== undefined
			? intl.formatMessage(selectedValue, { selected: currentValue.number, max })
			: intl.formatMessage(noValue, { max });

	return <Text testId="field-input-rating-view">{text}</Text>;
};
